module.exports = __webpack_public_path__ + "static/media/eye_close.a64f609a.svg";